<script setup>
import { onLaunch, onShow, onError, onLoad } from '@dcloudio/uni-app';
import { ShoproInit } from './sheep';
import AreaApi from '@/sheep/api/system/area';
import AuthUtil from '@/sheep/api/member/auth';
import HomeApi from '@/sheep/api/home/home';
import sheep from '@/sheep';
import Aegis from 'aegis-web-sdk';
import couponsApi from '@/sheep/api/coupons/coupons';
import eruda from 'eruda';
import { GetWhitePages } from './utils/visitorMode';
import { isWebView , randomId } from "@/utils/common";
import wx from 'weixin-js-sdk'

var baseUrl = import.meta.env.SHOPRO_BASE_URL;


onLaunch((options) => {
  console.log(options ,' 89');
  if (options.query.token) {
    uni.setStorageSync("token", options.query.token);
  }
  if (options.query.refreshToken) {
    uni.setStorageSync("refresh-token", options.query.refreshToken);
  }
  if (options.query.position) {
    uni.setStorageSync("positioning", JSON.parse(options.query.position));
  }
  if (options.query.openid) {
    uni.setStorageSync("openId", options.query.openid);
  }
  if (options.query.userId) {
    uni.removeStorageSync("userId");
    
    uni.setStorageSync("userId", options.query.userId);
  }
  if (options.query.isWeb) {
    sessionStorage.setItem("isWeb", options.query.isWeb);
  }
  const serviceId = uni.getStorageSync('serviceId') || ''
  if(!serviceId){
    uni.setStorageSync('serviceId' , randomId()) 
  }

  if (!!uni.getStorageSync('areaData')) {
  } else {
    // 提前加载省市区数据
    AreaApi.getAreaTree().then((res) => {
      if (res.code === 0) {
        uni.setStorageSync('areaData', res.data);
      }
    });
  }
  if (baseUrl === 'https://safe.api.fushangyunfu.com') {
    const aegis = new Aegis({
      id: 'xEj7ltQ5LkVK0l8K7Y', // 应用ID，即上报ID
      uin: '', //用户唯一 ID（可选）
      reportApiSpeed: true, //接口测速
      reportAssetSpeed: true, // 静态资源测速
      hostUrl: 'https://aegis.qq.com', // 上报域名，中国大陆 rumt-zh.com
      spa: true, //spa 应用页面跳转的时候开启 pv 计算
      api: {
        apiDetail: true,
      },
    });
    let userId = uni.getStorageSync('userId') || '';
    if (userId) {
      aegis.setConfig({
        uin: userId,
      });
    }
    const getUserIdSet = setInterval(() => {
      if (userId) {
        aegis.setConfig({
          uin: userId,
        });
        clearInterval(getUserIdSet);
      } else {
        userId = uni.getStorageSync('userId') || '';
      }
    }, 5000);
  }
  saveFirstPage();
  ShoproInit();

  // 加载Shopro底层依赖

  enterPageCheck();
  getUserInfo()

  if (window.location.href.indexOf('erudaType=eruda') > -1) {
    sessionStorage.setItem('erudaType', 'eruda')
  }
  let isShowErude = true
  if (isShowErude && sessionStorage.getItem('erudaType')) {
    isShowErude = false
    eruda.init()
  }

  // 预加载百度地图 API
  loadBaiduMap();
});

// 百度地图加载 Promise，供其他组件使用
let baiduMapLoadPromise = null;

/**
 * 加载百度地图 API
 * @returns {Promise} 返回 Promise，地图加载完成后 resolve
 */
async function loadBaiduMap() {
  // 如果已经加载过，直接返回
  if (window.BMap) {
    return Promise.resolve();
  }
  
  // 如果正在加载，返回现有的 Promise
  if (baiduMapLoadPromise) {
    return baiduMapLoadPromise;
  }
  
  // 创建新的加载 Promise
  baiduMapLoadPromise = new Promise(async (resolve, reject) => {
    try {
      // 获取百度地图 AK，优先从配置获取，否则使用默认值
      let ak = 'AHRpBFhQLiCGpDGLE283p55eFs1d071P'; // 默认 AK
      
      // 尝试从配置中获取
      try {
        const { data } = await HomeApi.getConfigValueByKey('baidu.map.ak');
        if (data) {
          ak = data;
        }
      } catch (e) {
        // 如果获取配置失败，使用默认值
        console.log('使用默认百度地图 AK');
      }
      
      // 使用唯一的回调函数名
      const callbackName = 'baiduMapInitCallback_' + Date.now();
      
      // 将回调函数挂载到 window
      window[callbackName] = () => {
        // 清理回调函数
        delete window[callbackName];
        // 移除 script 标签（可选）
        const script = document.querySelector(`script[src*="api.map.baidu.com"]`);
        if (script) {
          script.remove();
        }
        resolve();
      };
      
      // 创建并加载 script
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://api.map.baidu.com/api?v=2.0&ak=${ak}&callback=${callbackName}`;
      script.onerror = () => {
        delete window[callbackName];
        baiduMapLoadPromise = null;
        reject(new Error('百度地图 API 加载失败'));
      };
      document.head.appendChild(script);
    } catch (error) {
      baiduMapLoadPromise = null;
      reject(error);
    }
  });
  
  return baiduMapLoadPromise;
}

// 将加载函数暴露到全局，供其他组件使用
window.loadBaiduMap = loadBaiduMap;

const enterPageCheck = async () => {
  if (!uni.getStorageSync('token') && !uni.getStorageSync('refresh-token')) {
    sheep.$store("user").resetUserData();
  }

  let locationHref = window.location.href;
  let isWhitePage = false;
  // const { data } = await AuthUtil.getUserTypeObj('tourist.flag')
  const openVisitorMode = true
  uni.setStorageSync('openVisitorMode', openVisitorMode)
  if (locationHref.includes('pages')) {
    const arr = GetWhitePages(openVisitorMode);
    arr.map((item) => {
      if (locationHref.includes(item)) {
        isWhitePage = true;
        return;
      }
    });
  }
  else { //首页
    if (openVisitorMode) isWhitePage = true;
    else {
      if (uni.getStorageSync('token')) isWhitePage = true;
      else isWhitePage = false;
    }
  }
  // 判断登录
  // console.log(uni.getStorageSync('refresh-token'), '555', !uni.getStorageSync('token'));
  if (uni.getStorageSync('refresh-token') && !uni.getStorageSync('token')) {
    const refreshTokenResult = await AuthUtil.refreshToken(uni.getStorageSync('refresh-token'));
    if (refreshTokenResult.code === 0 && locationHref.indexOf('/pages/author/index') > -1) {
      sheep.$router.redirect('/pages/index/index');
    }
    if (refreshTokenResult.code !== 0 && !isWhitePage) {
      uni.removeStorageSync('refresh-token');
      if (isWebView()) {
        wx.miniProgram.navigateTo({
          url: '/pages/login/index'
        })
      } else {
        sheep.$router.redirect('/pages/author/index');
      }
      throw new Error('刷新令牌失败');
    }
  }
  if (!isWhitePage) {
    if (!uni.getStorageSync('token')) {
      if (isWebView()) {
        uni.showModal({
          title: '游客模式暂不支持该功能',
          content: '完成登录后可使用商城完整功能',
          cancelText: '继续体验',
          confirmText: '去登录',
          success: async res => {
            if (res.confirm) {
              wx.miniProgram.navigateTo({
                url: '/pages/login/index'
              })
            }
          }
        });
      } else {
        sheep.$router.redirect('/pages/author/index');
      }
    } else {

    }
  }
};
function saveFirstPage() {
  let locationHref = window.location.href;
  if (locationHref.indexOf('pages/author/index') === -1) {
    sessionStorage.setItem('entryUrl', locationHref);
    uni.setStorageSync('redirectUrl', locationHref)
  }
}

async function getUserInfo() {
  if (!uni.getStorageSync('token')) {
    return
  }
  sheep.$store('user').getInfo()
}

const getUserIdSet = () => { };
onError((err) => {
  // console.log('AppOnError:', err);
});

onShow((options) => {
  // #ifdef APP-PLUS
  // 获取urlSchemes参数
  const args = plus.runtime.arguments;
  if (args) {
  }

  // 获取剪贴板
  uni.getClipboardData({
    success: (res) => { },
  });
  // #endif

  // #ifdef MP-WEIXIN
  // 确认收货回调结果
  // #endif
});
</script>

<style lang="scss">
@import "uview-ui/index.scss";
// 引入vant-weapp样式
@import "@/sheep/scss/index.scss";
</style>
<style lang="scss">
// #ifdef  MP-WEIXIN
/* @import '/wxcomponents/@vant/weapp/common/index.wxss'; */
// #endif
@import "@/components/css/page.css";

.uni-tabbar {
  display: none;
}

uni-modal {
  z-index: 10075;
}

.alarmInfo {
  width: 100%;
  padding: 0 20rpx;
  box-sizing: border-box;
  height: 48rpx;
  display: flex;
  align-items: center;
  background-color: #FEF7E4;
  color: #EEB46C;
  font-size: 24rpx;
  font-weight: 600;
  z-index: 981;

}

.virtualInfo {
  width: 100%;
  padding: 0 20rpx;
  box-sizing: border-box;
  height: 48rpx;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #FEF7E4;
  color: #EEB46C;
  font-size: 24rpx;
  font-weight: 600;
  z-index: 981;

}

.virtualInfo .left {
  display: flex;
  align-items: center;
}

.zhezhao {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 19999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .tcImg {
    width: 100%;
    height: auto;
  }

  .zheZaoBtn {
    margin-top: 30rpx;
    width: 72rpx;
    height: 72rpx;
  }
  .closeBtn{
    position: relative;
    top: -100rpx;
    width: 100rpx;
    height: 80rpx;
  }
}

.WPH {
  background: linear-gradient(137deg, #FF74A2 0%, #FF6095 22%, #FF377A 100%) !important;
}

.TM {
  background: #00CD00 !important;
}
</style>
